
import React,{ useState } from "react";
import { Rating } from "@mui/material";

const StarRating = ({ value = 0, onChange = null, precision = 0.5,customSize=null }) => {
  return (
    <Rating
      name="star-rating"
      value={value}
      precision={precision} // Allows decimal values like 3.5 or 4.75
      onChange={(_, newValue) => onChange && onChange(newValue)}
      readOnly={!onChange} // If no onChange, it becomes display-only
      sx={customSize ? { fontSize: customSize } : {}}
    />
  );
};

export default StarRating;
